import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIList from 'UIComponents/list/UIList';
import useLocale from 'developer-docs-shared-components/hooks/useLocale';
import { connect, useDispatch } from 'react-redux';
import { selectSearchResults, selectTotalResultCount } from '../../selectors/searchState';
import OldSiteRedirectAlert from './OldSiteRedirectAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'UIComponents/elements/headings';
import styled from 'styled-components';
import { selectSearchQuery } from '../../selectors/searchState';
import { SEARCH, SEARCH_ACTIONS, SEARCH_ORIGINS } from '../../tracking/trackerActions';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import { ResultIcon } from './ResultIcon';
import ResultDescription from './dropdownSearch/ResultDescription';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import { MOBILE_MENU_BREAKPOINT, mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { search } from '../../actions/SearchActions';
import { getOffsetFromPage, getSearchResultsPageUrl, resultPerPage } from './searchHelpers';
import { SeeEnglishResults } from './SeeEnglishResults';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "ResultsPage__StyledCardWrapper",
  componentId: "sc-1ok4wpb-0"
})(["margin-bottom:0;padding-left:20px;padding-right:20px;", "{padding-left:60px;padding-right:60px;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT));
function ResultsPage({
  query,
  searchResults,
  totalResultCount,
  pageNumber
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const offset = useMemo(() => getOffsetFromPage(pageNumber), [pageNumber]);
  const locale = useLocale();
  const handlePageChange = e => {
    const selectedPageIndex = parseInt(e.currentTarget.value, 10);
    const path = getSearchResultsPageUrl(query, selectedPageIndex);
    dispatch(search(query, locale, getOffsetFromPage(selectedPageIndex)));
    history.push(path);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [locale !== 'en-us' && /*#__PURE__*/_jsx("div", {
      className: "p-bottom-4",
      children: /*#__PURE__*/_jsx(SeeEnglishResults, {
        query: query
      })
    }), /*#__PURE__*/_jsxs(StyledCardWrapper, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "p-top-6",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-ui.search.resultsForQuery",
          options: {
            query
          }
        })
      }), /*#__PURE__*/_jsx(UIList, {
        "data-test-id": "search-results",
        children: searchResults.map((result, i) => /*#__PURE__*/_jsxs(UICardSection, {
          className: "p-y-8 p-x-0 flex-row align-center justify-between",
          children: [/*#__PURE__*/_jsx(ResultDescription, {
            onClick: () => getUsageTracker().track(SEARCH, {
              action: SEARCH_ACTIONS.RESULT_SELECTED,
              origin: SEARCH_ORIGINS.STANDARD_SEARCH,
              searchTerm: query,
              offset: offset || 0,
              link: `/${result.link}`
            }),
            query: query,
            result: result
          }), /*#__PURE__*/_jsx(ResultIcon, {
            badge: result.badge
          })]
        }, i))
      }), /*#__PURE__*/_jsx("div", {
        className: "flex-column align-center",
        children: /*#__PURE__*/_jsx(UIPaginator, {
          className: "p-bottom-10 p-x-10",
          onPageChange: handlePageChange,
          page: pageNumber || 1,
          pageCount: Math.ceil(totalResultCount / resultPerPage),
          showLastPageNumber: true
        })
      })]
    }), /*#__PURE__*/_jsx(OldSiteRedirectAlert, {
      className: "p-top-4"
    })]
  });
}
const mapStateToProps = state => ({
  query: selectSearchQuery(state),
  searchResults: selectSearchResults(state),
  totalResultCount: selectTotalResultCount(state)
});
export default connect(mapStateToProps)(ResultsPage);